export default "__VITE_ASSET__B78oYi7M__"